
import {SemesterGetLicense, SemesterSave, SemesterDelete, SemesterExport} from "services/semesterService";
import {useParams, useHistory, Link} from "react-router-dom";
import { useEffect, useState } from "react";
import SubjectPlanningPage from "components/SubjectPlanningPage";
import ErrorModal from "popup/ErrorModal";
import {FaArrowLeft} from "react-icons/fa";
import LoadingOverlay from "components/Static/LoadingOverlay";
import DownloadingOverlay from "components/Static/DownloadingOverlay";
import {toast} from "react-hot-toast";
import { ArrowLeft } from 'lucide-react';
export default function LicenseClassTrainingPlan() {
    const router = useHistory()
    const {licenseClassId}: any = useParams();
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [isExporting, setIsExporting] = useState(false);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await SemesterGetLicense(licenseClassId);
            if (response.result) {
                setData(response.result);
            } else {
                setErrorMessage("Không tìm thấy dữ liệu");
                setErrorModalOpen(true);
            }
        } catch (err: any) {
            const errorMsg = err?.responseException?.exceptionMessage
                || err?.message
                || "Lỗi khi tải dữ liệu";
            setErrorMessage(errorMsg);
            setErrorModalOpen(true);
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (licenseClassId) {
            fetchData();
        }
    }, [licenseClassId]);

    const handleSubjectSubmit = async (subjectData: any) => {
        try {
            setLoading(true);
            const payload = {
                ...subjectData,
                id: subjectData.id || null
            };
            const response = await SemesterSave(payload);

            if (!response.message) {
                throw new Error("Lỗi khi lưu môn học: " + response?.message);
            }

            await fetchData();
            toast.success("Lưu môn học thành công");
        } catch (error: any) {
            const errorMsg = error?.responseException?.exceptionMessage
                || error?.message
                || "Lỗi khi lưu môn học";
            setErrorMessage(errorMsg);
            setErrorModalOpen(true);
            console.error("Lỗi khi lưu môn học:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteSubject = async (id: string) => {
        try {
            setLoading(true);
            const response = await SemesterDelete(id);
            await fetchData(); // Làm mới dữ liệu sau khi xóa
            toast.success("Xóa môn học thành công");
        } catch (error: any) {
            const errorMsg = error?.responseException?.exceptionMessage
                || error?.message
                || "Lỗi khi xóa môn học";
            setErrorMessage(errorMsg);
            setErrorModalOpen(true);
            console.error("Lỗi khi xóa môn học:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleExportSemester = async () => {
        try {
            setIsExporting(true);
            const blob = await SemesterExport({
                licenseClassId: licenseClassId
            });

            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            const now = new Date();
            const timestamp = `${now.getFullYear()}${(now.getMonth()+1).toString().padStart(2, '0')}${now.getDate().toString()
                .padStart(2, '0')}-${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;

            link.href = downloadUrl;
            link.setAttribute('download', `KHHT-${timestamp}.xlsx`);
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.parentNode?.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
            setIsExporting(false);
            toast.success("Xuất kế hoạch học tập thành công");
        } catch (error: any) {
            const errorMsg = error?.responseException?.exceptionMessage
                || error?.message
                || "Lỗi";
            setErrorMessage(errorMsg);
            setErrorModalOpen(true);
        } finally {
            setIsExporting(false);
        }
    };


    if (loading) {
        return (
            <LoadingOverlay message="Đang tải dữ liệu..." />
        );
    }

    if (isExporting){
        return (<DownloadingOverlay />);
    }

    if (!data) {
        return (
            <div className="p-4">
                <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
                    Không có dữ liệu để hiển thị
                    <button
                        onClick={fetchData}
                        className="mt-2 ml-2 bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-1 px-3 rounded"
                    >
                        Thử lại
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="mx-auto">
            <div className="grid grid-cols-1 gap-8">
                <div className="bg-white rounded-lg shadow-md p-6">
                    <button
                        onClick={() => router.push(`/training-plans`)}
                        className="flex items-center px-4 py-2 mb-5 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
                    >
                        <ArrowLeft className="mr-2"/>
                        Quay lại danh sách
                    </button>
                    <SubjectPlanningPage
                        data={data}
                        onSubjectSubmit={handleSubjectSubmit}
                        onRefresh={fetchData}
                        onDeleteSubject={handleDeleteSubject}
                        onExport={handleExportSemester}
                    />

                    <ErrorModal
                        isOpen={errorModalOpen}
                        message={errorMessage}
                        onClose={() => setErrorModalOpen(false)}
                    />
                </div>
            </div>
        </div>
    );
}